import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AlertProvider, ModalProvider, ThemeProvider } from "matsuri-ui";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "../domain/api/auth";
import { theme } from "../theme";
import { DragAndDropProvider } from "./DragAndDropProvider";
import { ErrorBoundaryProvider } from "./ErrorBoundaryProvider";
import { GlobalStyleProvider } from "./GlobalStyleProvider";
export const AppProvider = ({ children, }) => {
    return (_jsx(ErrorBoundaryProvider, { children: _jsx(BrowserRouter, { children: _jsx(ThemeProvider, { theme: theme, children: _jsx(AuthProvider, { children: _jsx(AlertProvider, { children: _jsx(DragAndDropProvider, { children: _jsx(GlobalStyleProvider, { children: _jsx(ModalProvider, { children: children }) }) }) }) }) }) }) }));
};
